import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'

import { PvzKeys } from '../../../data'
import { PvzAreaViewModel } from '../../../stores/models/PvzAreaModel'

const getKey = (key: string) => `${PvzKeys.editAreaPage}.validate.${key}`
const getOrderKey = (key: string) => `${OrderKeys.workConditionsStep}.validate.${key}`

export class ValidatePvzEditArea extends ValidateFormService {
  validate = (model: PvzAreaViewModel) => {
    const errors: string[] = []

    if (!model.area) {
      errors.push(i18next.t(getOrderKey('areaRequired')))
    } else {
      if (+model.area < 1) {
        errors.push(i18next.t(getOrderKey('areaMin'), { count: 1 }))
      }
    }

    if (!model.warehouseArea) {
      errors.push(i18next.t(getOrderKey('warehouseAreaRequired')))
    } else {
      if (+model.warehouseArea < 1) {
        errors.push(i18next.t(getOrderKey('warehouseAreaMin'), { count: 1 }))
      }
    }

    if (model.invalidEditAreaDocuments) {
      errors.push(i18next.t(getKey('invalidEditAreaDocuments')))
    }

    return this.hasNotErrors(errors)
  }
}

export const validatePvzEditArea = new ValidatePvzEditArea()
